import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "damage-report-wrapper" }
const _hoisted_2 = { class: "img-list" }
const _hoisted_3 = { class: "image-slot" }
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 1,
  class: "no-data"
}

import { ref, onMounted } from 'vue'
import { PictureFilled } from '@element-plus/icons-vue'
import {
  getEvCarDamageReports,
  markDamageReportResolved,
} from '@/api/car-ev-data'
import { getUserDetails } from '@/api/user'

interface DamageReport {
  id: string
  description: string
  status: string
  user_id: string
  images: Array<{ public_id: string; secure_url: string }>
  created_at: string
}

interface User {
  id: string
  first_name: string
  last_name: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EvCarDamageReport',
  props: {
    vehicle: {}
  },
  emits: ["update-opened-count"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const reports = ref<DamageReport[]>([])
const users = ref<Record<string, User>>({})
const loading = ref(false)
const error = ref('')

const fetchReports = async () => {
  loading.value = true
  error.value = ''
  try {
    const response = await getEvCarDamageReports(props.vehicle.id)
    reports.value = response.data.data

    const opened = reports.value.filter(r => r.status === 'opened').length
    emit('update-opened-count', opened)

    const uniqueUserIds = [...new Set(reports.value.map(r => r.user_id))]

    await Promise.all(
      uniqueUserIds.map(async userId => {
        if (!users.value[userId]) {
          try {
            const res = await getUserDetails(userId)
            const userData: User = {
              id: res.data.data.id,
              first_name: res.data.data.first_name || '',
              last_name: res.data.data.last_name || '',
            }
            users.value[userId] = userData
          } catch (userErr) {
            console.error(`❌ Failed to fetch user ${userId}`, userErr)
          }
        }
      })
    )
  } catch (err) {
    console.error('❌ Failed to load damage reports:', err)
    error.value = 'Failed to load damage reports'
  } finally {
    loading.value = false
  }
}

const markResolved = async (reportId: string) => {
  try {
    await markDamageReportResolved(reportId)
    const target = reports.value.find(r => r.id === reportId)
    if (target) target.status = 'resolved'

    const opened = reports.value.filter(r => r.status === 'opened').length
    emit('update-opened-count', opened)
  } catch (err) {
    console.error('❌ Failed to mark report as resolved:', err)
  }
}

onMounted(fetchReports)

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (reports.value.length)
      ? (_openBlock(), _createBlock(_component_el_table, {
          key: 0,
          data: reports.value,
          style: {"width":"100%"},
          class: "damage-reports-table"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "created_at",
              label: "Created At",
              width: "180"
            }),
            _createVNode(_component_el_table_column, {
              prop: "description",
              label: "Description"
            }),
            _createVNode(_component_el_table_column, {
              prop: "status",
              label: "Status",
              width: "120"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_tag, {
                  type: row.status === 'resolved' ? 'success' : 'danger'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.status), 1)
                  ]),
                  _: 2
                }, 1032, ["type"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "Images" }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.images, (img) => {
                    return (_openBlock(), _createBlock(_component_el_image, {
                      key: img.public_id,
                      src: img.secure_url,
                      "preview-src-list": [img.secure_url],
                      style: {"width":"60px","height":"60px","margin-right":"8px"},
                      fit: "cover"
                    }, {
                      error: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_el_icon, { class: "image-slot-icon" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(PictureFilled))
                            ]),
                            _: 1
                          }),
                          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "image-slot-text" }, "Image not available", -1))
                        ])
                      ]),
                      _: 2
                    }, 1032, ["src", "preview-src-list"]))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "User",
              width: "200"
            }, {
              default: _withCtx(({ row }) => [
                (users.value[row.user_id])
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: `/users/${row.user_id}`,
                      target: "_blank",
                      style: {"text-decoration":"underline"}
                    }, _toDisplayString(users.value[row.user_id].first_name) + " " + _toDisplayString(users.value[row.user_id].last_name), 9, _hoisted_4))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("Loading...")
                    ], 64))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Actions",
              width: "150"
            }, {
              default: _withCtx(({ row }) => [
                (row.status === 'opened')
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      size: "small",
                      onClick: ($event: any) => (markResolved(row.id))
                    }, {
                      default: _withCtx(() => _cache[1] || (_cache[1] = [
                        _createTextVNode(" Resolved ")
                      ])),
                      _: 2,
                      __: [1]
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]))
      : (!loading.value && !error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "No damage reports"))
        : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createBlock(_component_el_skeleton, {
          key: 2,
          rows: "4",
          animated: ""
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})